import { decodeClassifierMappingOptionValue } from '../../../../classifier-mapping';
import { decodeAlgorithmSourceDimensionOptionValue } from '../../sources/utils';
import { AlgorithmMappingValidFormDataSchema } from './AlgorithmMappingValidFormDataSchema';

export const AlgorithmMappingMutationDtoSchema =
  AlgorithmMappingValidFormDataSchema.transform(
    ({ id, alias, joinTypeCode, sourceDimension, classifierMapping }) => {
      const { dimensionCode, algorithmSourceId, dataObjectCode } =
        decodeAlgorithmSourceDimensionOptionValue(sourceDimension);

      const { classifierMappingId } =
        decodeClassifierMappingOptionValue(classifierMapping);

      return {
        id,
        alias,
        joinTypeCode,
        algorithmSourceId,
        dataObjectDescriptionCode: dataObjectCode,
        sourceDimension: dimensionCode,
        classifierMappingId,
      };
    },
  );
